import { getButtonProps } from './getTextColorButtonProps.js';
import TextColorButton from './TextColorButton.js';
import TextHighlightButton from './TextHighlightButton.js';
import { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE } from '../types.js';
import { FORMATTING_BUTTONS } from 'wix-rich-content-editor-common';
import 'react';
import './TextColorPanel.js';
import 'prop-types';
import 'wix-rich-content-plugin-commons';
import '../constants.js';
import '../text-decorations-utils.js';
import 'wix-rich-content-common';
import '../color-scheme-utils.js';
import 'lodash';
import './TextColorIcon.js';
import './TextHighlightIcon.js';
import './BaseTextColor.js';
import 'classnames';
import 'react-modal';

const createTextColorToolbar = (config) => ({
  TextButtonMapper: () => ({
    [FORMATTING_BUTTONS.TEXT_COLOR]: {
      component: TextColorButton,
      externalizedButtonProps: getButtonProps({ config, type: TEXT_COLOR_TYPE })
    }
  }),
  name: "text-color"
});
const createTextHighlightToolbar = (config) => ({
  TextButtonMapper: () => ({
    [FORMATTING_BUTTONS.TEXT_HIGHLIGHT]: {
      component: TextHighlightButton,
      externalizedButtonProps: getButtonProps({ config, type: TEXT_HIGHLIGHT_TYPE })
    }
  }),
  name: "text-highlight"
});

export { createTextColorToolbar, createTextHighlightToolbar };
//# sourceMappingURL=createToolbar.js.map
